import Vue from 'vue'
import Router from 'vue-router'

import About from '../views/About.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Create from '../views/Create.vue'
import CertView from '../views/CertView.vue'
import Lost from '../views/Lost.vue'
import PasswordReset from '../views/PasswordReset.vue'
import PasswordResetConfirm from '../views/PasswordResetConfirm.vue'
import Register from '../views/Register.vue'
import VerifyEmail from '../views/VerifyEmail.vue'

import store from '../store'

const requireAuthenticated = (to, from, next) => {
    store.dispatch('auth/initialize').then(() => {
        if (!store.getters['auth/isAuthenticated']) {
            next('/login')
        } else {
            next()
        }
    })
}

const requireUnauthenticated = (to, from, next) => {
    store.dispatch('auth/initialize').then(() => {
        if (store.getters['auth/isAuthenticated']) {
            next('/home')
        } else {
            next()
        }
    })
}

const redirectLogout = (to, from, next) => {
    store.dispatch('auth/logout').then(() => next('/login'))
}

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/about',
            component: About,
            beforeEnter: requireAuthenticated
        },
        {
            path: '/home',
            component: Home,
            beforeEnter: requireAuthenticated
        },
        {
            path: '/password_reset',
            component: PasswordReset
        },
        {
            path: '/password_reset/:uid/:token',
            component: PasswordResetConfirm
        },
        {
            path: '/register',
            component: Register
        },
        {
            path: '/register/:key',
            component: VerifyEmail
        },
        {
            path: '/login',
            component: Login,
            beforeEnter: requireUnauthenticated
        },
        {
            path: '/logout',
            beforeEnter: redirectLogout
        },
        {
            path: '/create',
            component: Create,
            beforeEnter: requireAuthenticated
        },
        {
            path: '/view',
            component: CertView,
            beforeEnter: requireAuthenticated
        },
        {
            path: '*',
            component: Lost
        }
    ]
})
